var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500", persistent: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _vm.flota
                    ? _c(
                        "v-btn",
                        _vm._g(
                          { attrs: { color: "primary", dark: "", block: "" } },
                          on
                        ),
                        [_vm._v("Asignar Flota\n      ")]
                      )
                    : _vm._e(),
                  _vm.vehiculo
                    ? _c(
                        "v-btn",
                        _vm._g(
                          { attrs: { flat: "", icon: "", color: "primary" } },
                          on
                        ),
                        [_c("v-icon", [_vm._v("local_shipping")])],
                        1
                      )
                    : _vm._e()
                ]
              }
            }
          ]),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  "Asignar " +
                    _vm._s(
                      _vm.flota
                        ? _vm.flota.nombre
                        : _vm.vehiculo.patente_vehiculo
                    ) +
                    " a un\n        cliente\n      "
                )
              ]),
              _c(
                "v-card-text",
                [
                  _c("ClientFilter", {
                    model: {
                      value: _vm.client,
                      callback: function($$v) {
                        _vm.client = $$v
                      },
                      expression: "client"
                    }
                  })
                ],
                1
              ),
              _c("v-card-text", { staticStyle: { color: "red" } }, [
                _vm._v(
                  "Si usted asigna una flota completa al cliente, se le asignarán todos\n        los vehículos de la flota al cliente (No aplica para Transportistas\n        que no tienen su propia flota)\n      "
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.asignar } },
                    [_vm._v("Asignar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }